import { type OfficeGroup } from './types';

/**
 * Parses a "Last, First" provider name string into its components.
 */
export function parseProviderName(name: string | null): { first_name: string; last_name: string } {
  if (!name) return { first_name: '', last_name: '' };
  const [last_name = '', first_name = ''] = name.split(', ');
  return { first_name, last_name };
}

/**
 * Stable key for grouping/selecting offices by shared name + TIN.
 */
export function officeGroupKey(group: Pick<OfficeGroup, 'name' | 'tin'>): string {
  return `${group.name}::${group.tin ?? ''}`;
}

/**
 * Splits a full address string into a street portion and a city/state line.
 */
export function splitAddress(address: string): { street: string; cityLine: string } {
  const parts = address.split(',').map((p) => p.trim());
  if (parts.length <= 2) {
    return { street: address, cityLine: '' };
  }
  return {
    street: parts.slice(0, -2).join(', '),
    cityLine: parts.slice(-2).join(', '),
  };
}
